export const REFETCH_FADE_TRANSITION_CLASS = 'transition-opacity duration-200';

export const REFETCHING_OPACITY_CLASS = 'opacity-60';
